'use client';

import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import type { Testimonial } from '@/lib/content-schema';

interface Props {
  testimonials: Testimonial[];
}

export function OrganizerProof({ testimonials }: Props) {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [testimonials.length]);

  return (
    <section id="testimonios" className="py-24 md:py-32 bg-zibarit-bone">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="max-w-3xl mx-auto text-center">
          <div className="relative min-h-[200px]">
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={currentTestimonial}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                className="absolute inset-0"
              >
                <p className="text-title text-xl md:text-2xl text-zibarit-negro mb-6">
                  &ldquo;{testimonials[currentTestimonial].quote}&rdquo;
                </p>
              </motion.blockquote>
            </AnimatePresence>
          </div>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-2 h-2 rounded-full transition-colors ${
                  index === currentTestimonial
                    ? 'bg-zibarit-verde-oscuro'
                    : 'bg-zibarit-marron-secundario hover:bg-zibarit-marron-oscuro'
                }`}
                aria-label={`Ver testimonio ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
